export var contactUsInfo = {
    profileTypes: [
        {
            id: 1,
            name: "Consultant"
        },
        {
            id: 2,
            name: "Owner"
        },
        {
            id: 3,
            name: "Contractor"
        },
        {
            id: 4,
            name: "Manufacturer"
        },
        {
            id: 5,
            name: "Other"
        }
    ],
    profileOptions: [
        {
            id: 1,
            profileTypeId: 1,
            name: "Roofing - Consultant"
        },
        {
            id: 2,
            profileTypeId: 1,
            name: "Building Envelope - Consultant"
        },
        {
            id: 3,
            profileTypeId: 1,
            name: "Architect - Consultant"
        },
        {
            id: 4,
            profileTypeId: 1,
            name: "Engineer - Consultant"
        },
        {
            id: 5,
            profileTypeId: 1,
            name: "Other - Consultant"
        },
        {
            id: 6,
            profileTypeId: 2,
            name: "Property Manager"
        },
        {
            id: 7,
            profileTypeId: 2,
            name: "Corporate - Building Owner"
        },
        {
            id: 8,
            profileTypeId: 2,
            name: "Public - Building Owner"
        },
        {
            id: 9,
            profileTypeId: 2,
            name: "Other - Building Owner"
        },
        {
            id: 10,
            profileTypeId: 3,
            name: "Roofing Services"
        },
        {
            id: 11,
            profileTypeId: 3,
            name: "Building Envelope - Contractor"
        },
        {
            id: 12,
            profileTypeId: 3,
            name: "Other - Contractor"
        },
        {
            id: 13,
            profileTypeId: 4,
            name: "Roofing Materials- Manufacturer"
        },
        {
            id: 14,
            profileTypeId: 4,
            name: "Building Envelope Materials - Manufacturer"
        },
        {
            id: 15,
            profileTypeId: 4,
            name: "Other - Contractor"
        },
        {
            id: 16,
            profileTypeId: 5,
            name: "Industry Organization"
        },
        {
            id: 17,
            profileTypeId: 5,
            name: "Trade Group"
        },
        {
            id: 18,
            profileTypeId: 5,
            name: "Other"
        }
    ],
    productTypes: [
        {
            id: 1,
            groupName: "SaaS Cloud",
            name: "FM-Pro"
        },
        {
            id: 2,
            groupName: "Asset Modules",
            name: "RoofPro"
        },
        {
            id: 3,
            groupName: "Asset Modules",
            name: "WallPro"
        },
        {
            id: 4,
            groupName: "Asset Modules",
            name: "PavePro"
        },
        {
            id: 5,
            groupName: "Asset Modules",
            name: "VTPro"
        },
        {
            id: 6,
            groupName: "Other",
            name: "Legacy Software System"
        }
    ],
    contactSchedule: [
        {
            id: 1,
            name: "Right away!"
        },
        {
            id: 2,
            name: "Next 3 days"
        },
        {
            id: 3,
            name: "Next 7 days"
        }
    ]
}

export default contactUsInfo;